import { createFileRoute } from "@tanstack/react-router";

import { InfraCenter } from "@/pages/admin/InfraCenter";

export const Route = createFileRoute("/admin/infra")({
  component: InfraCenter,
});
